import React, { useState, useEffect } from "react";
import { useQuery, useDelete, useDetail, useSet } from "seed/gql";
import { Loading } from "seed/helpers";
import { SET_PARTICIPANT } from "seed/gql/queries";
import { DELETE_PARTICIPANT } from "seed/gql/queries";
import { APP_URL } from "settings";
import View from "components/presentation/forms/collaboration/Collaboration.view";


function Collaboration({ flowId }) {

  const userId = sessionStorage.getItem("id");
  const [isAccessModelOpen, setIsAccessModelOpen] = useState(false);

  const reqRoles = useQuery(`{
      participantRoles {
        name
      }
    }`, `flow.id=${flowId}`, {
    notifyOnNetworkStatusChange: false
  });

  const reqUsers = useQuery(`{
    users {
      email
      firstName
      lastName
      username
      participants {
        flow { name }
      }
    }
  }`, `id <> ${userId} AND isAnonymous=False`, {
    notifyOnNetworkStatusChange: false
  })

  const reqParticipants = useQuery(`{
    participants {
      channel
      email
      phone
      user {
        email
        phone
        firstName
        lastName
        username
      }
      organization {
        name
        description
        organizationParticipants {
          type
          user {
            email
            phone
            firstName
            lastName
            username
          }
        }
      }
      role {
        name
      }
      settings
    }
  }`, `flow.id = ${flowId}`, {
    notifyOnNetworkStatusChange: false
  })

  const reqFlow = useDetail(`{
     flow {
       name
       token
       settings
       user {
        firstName
        lastName
        email
       }
     } 
    }`, flowId, {
    notifyOnNetworkStatusChange: false
  })

  const reqOrganizations = useQuery(`{
    organizations {
      name
      owner { 
        username 
      }
    }
  }`, {
    notifyOnNetworkStatusChange: false
  })

  const [callDelete] = useDelete(DELETE_PARTICIPANT, {
    onCompleted: () => {
      reqUsers.refetch();
      reqParticipants.refetch();
    },
    onError: (err) => {
      console.log(err);
    }
  })

  useEffect(() => {
    reqRoles.refetch();
    reqUsers.refetch();
    reqParticipants.refetch();
    reqFlow.refetch();
    reqOrganizations.refetch();
  }, []);

  const onCloseAccessModel = () => {
    setIsAccessModelOpen(false);
  }

  const onOpenAccessModel = () => {
    setIsAccessModelOpen(true);
  }

  const [callSetRoleParticipant, reqSetRoleParticipant] = useSet(SET_PARTICIPANT)

  const onClickChangeOrganizationParticipantRole = (participant, orgParticipant, newRole) => {
    const settings = Object.assign({}, participant.settings || {});
    settings.roles = Object.assign({}, settings.roles || {});
    settings.roles[orgParticipant.user.id] = parseInt(newRole);
    callSetRoleParticipant({
      id: participant.id,
      settings
    });
  }

  const onChangeParticipantRole = (participantId, newRole) => {
    callSetRoleParticipant({
      id: participantId,
      role: parseInt(newRole)
    })
  }

  const onClickRemoveParticipant = (participantId) => {
    callDelete({ id: participantId });
  }

  const onCompleteAccess = () => {
    setIsAccessModelOpen(false);
    reqUsers.refetch();
    reqParticipants.refetch();
  }

  if (reqRoles.loading || reqUsers.loading || reqParticipants.loading || reqFlow.loading || reqOrganizations.loading) return <Loading />;
  if (reqRoles.error || reqUsers.error || reqParticipants.error || reqFlow.error || reqOrganizations.error) return <div />;

  const { participants = [] } = reqParticipants.data;
  const { participantRoles = [] } = reqRoles.data;
  const { flow = {} } = reqFlow.data
  const url = decodeURIComponent(`${APP_URL}/app/${flow.token}`)

  const roleOptions = participantRoles.map(role => ({
    value: role.id,
    label: role.name
  }));

  return (
    <View
      flow={flow}
      url={url}
      participants={participants}
      roleOptions={roleOptions}
      reqParticipants={reqParticipants}
      isAccessModelOpen={isAccessModelOpen}
      onCompleteAccess={onCompleteAccess}
      onChangeParticipantRole={onChangeParticipantRole}
      onClickChangeOrganizationParticipantRole={onClickChangeOrganizationParticipantRole}
      onClickRemoveParticipant={onClickRemoveParticipant}
      onOpenAccessModel={onOpenAccessModel}
      onCloseAccessModel={onCloseAccessModel}
    />
  );
}

export default Collaboration;